/* ============
 * Mutation types for the auth module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const CHECK = 'CHECK'
export const REGISTER = 'REGISTER'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_PERMISSIONS = 'SET_PERMISSIONS'

export default {
  CHECK,
  REGISTER,
  LOGIN,
  LOGOUT,
  SET_PERMISSIONS
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/mutation-types.js